import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getToken, getUser, isTokenExpired } from '../services/auth';
import { encerrarSessao, paginaInicialDoPapel } from '../services/sessao';

const PrivateRoute = ({ children, roles }) => {
  const location = useLocation();
  const token = getToken();
  const venceu = Boolean(token) && isTokenExpired(token);

  // Token vencido: vai ao login com o aviso e lembra esta página para voltar depois.
  useEffect(() => {
    if (venceu) encerrarSessao('expirada');
  }, [venceu]);

  if (venceu) return null;

  const user = getUser();

  if (!token || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Papel sem acesso a esta página: vai para a página inicial do próprio papel
  // (mandar todos para /dashboard, que é só de USUARIO, criava um loop).
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={paginaInicialDoPapel(user.role)} replace />;
  }

  return children;
};

export default PrivateRoute;
